import CSRFTokenResolver from "../../global/CSRFTokenResolver";

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from "laravel-echo";

window.Pusher = require('pusher-js');

window.Echo = new Echo({
    broadcaster: 'pusher',
    key: '2f56877bc7388f6893bf',
    cluster: 'eu',
    encrypted: true,
    namespace: 'Modules.Member.Events.LiveChat'
});

window.axios = require('axios');

window.axios.defaults.headers.common = {
    'X-CSRF-TOKEN': CSRFTokenResolver.getToken(),
    'X-Requested-With': 'XMLHttpRequest'
};

window.Echo.connector.pusher.connection.bind('connected', function () {
    window.axios.defaults.headers.common['X-Socket-ID'] = window.Echo.socketId();
});